export { default } from './DialogActions';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/DialogActions/index.js
// module id = 233
// module chunks = 2